import project from "@/config.json";

let config = {
  bsvTxidUrl: "http://bsv.mempool.com/TransactionDetail/",
  btcTxidUrl: "http://btc.mempool.com/w/TransactionDetails/",
  getcode: "https://www.ddpurse.com/openapi/v1/codes",
};

export default config;
